var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhatsapp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0_whatsapp{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_whatsapp);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "WA_Logo_2_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_whatsapp",
    gradientUnits: "userSpaceOnUse",
    x1: 7.9257,
    y1: 14.8474,
    x2: 40,
    y2: 14.8474,
    gradientTransform: "matrix(1 0 0 1 -2.6964 5.1526)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#27CD44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#5FFB7C"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0_whatsapp",
    d: "M32.63,8.57c-3.02-3.02-7.02-4.68-11.3-4.68c-8.8,0-15.97,7.16-15.97,15.96c0,2.81,0.73,5.56,2.13,7.98 l-2.27,8.27l8.47-2.22c2.33,1.27,4.96,1.94,7.63,1.94h0.01c8.8,0,15.97-7.16,15.97-15.96C37.31,15.6,35.65,11.59,32.63,8.57z  M21.33,33.14L21.33,33.14c-2.39,0-4.72-0.64-6.76-1.85L14.09,31l-5.02,1.32l1.34-4.9l-0.32-0.5c-1.33-2.11-2.03-4.55-2.03-7.06 c0-7.32,5.96-13.27,13.28-13.27c3.55,0,6.88,1.38,9.38,3.89c2.51,2.51,3.89,5.84,3.88,9.39C34.6,27.18,28.65,33.14,21.33,33.14z  M28.61,23.2c-0.4-0.2-2.36-1.16-2.73-1.3s-0.63-0.2-0.9,0.2c-0.27,0.4-1.03,1.3-1.26,1.56s-0.47,0.3-0.86,0.1 c-0.4-0.2-1.68-0.62-3.21-1.98c-1.19-1.06-1.99-2.36-2.22-2.76s-0.02-0.62,0.17-0.81c0.18-0.18,0.4-0.47,0.6-0.7 c0.2-0.23,0.27-0.4,0.4-0.67c0.13-0.27,0.07-0.5-0.03-0.7c-0.1-0.2-0.9-2.16-1.23-2.96c-0.32-0.78-0.65-0.67-0.9-0.68 c-0.23-0.01-0.5-0.01-0.76-0.01c-0.27,0-0.7,0.1-1.06,0.5c-0.37,0.4-1.4,1.36-1.4,3.33s1.43,3.86,1.63,4.13 c0.2,0.27,2.81,4.3,6.82,6.02c0.95,0.41,1.7,0.66,2.27,0.84c0.96,0.3,1.83,0.26,2.51,0.16c0.77-0.11,2.36-0.97,2.69-1.9 c0.33-0.93,0.33-1.73,0.23-1.9S29.01,23.4,28.61,23.2z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsapp);
export default __webpack_public_path__ + "static/media/Whatsapp.dc2515ced8cc5a49f7f512887117ab44.svg";
export { ForwardRef as ReactComponent };